
<mat-sidenav-container class="sidenav-container body-1-regular-2">
    <!-- Right sidenav -->
    <mat-sidenav #rightSidenav mode="side" position="end" class="sidenav-right"
                 [fixedInViewport]="false" [fixedTopGap]="0"
                 [fixedBottomGap]="0">

      <div class="sidenav-right-content" fxLayout="column" fxLayoutGap="15px">
        <div class="pane right-pane" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div class="body-2-default" fxLayout="row">
<!--            Switch View-->
          </div>

          <mat-tab-group (selectedTabChange)="switchTabs($event)" [(selectedIndex)]="selectedTabIndex"
                         class="custom-tab-group" mat-align-tabs="start"
                         mat-stretch-tabs="false" [preserveContent]="true">
            <mat-tab>
                <ng-template mat-tab-label>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                        <div class="square-icon icon-smaller">
                            <mat-icon svgIcon="stacked_lines"></mat-icon>
                        </div>
                        <span class="body-1-default">Details</span>
                    </div>
                </ng-template>
              <app-edit-single-space #editSpaceComponent
                [selectedSpace]="selectedSpace"
                (dirty)="selectedSpaceDirty = $event"
                (spaceUpdated)="updatedSpace = $event"
                [addNewSpace]="addNewSpace">
              </app-edit-single-space>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
                        <div class="square-icon icon-smaller">
                            <mat-icon class="material-icons-outlined">price_change</mat-icon>
                        </div>
                        <span class="body-1-default">Rates</span>
                    </div>
                </ng-template>
              <app-edit-single-space-default-pricing #editSpacePricingComponent
                [selectedSpace]="selectedSpace"
                (dirty)="selectedSpacePricingDirty = $event"
                (spaceUpdated)="updatedSpace = $event">
              </app-edit-single-space-default-pricing>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>

    </mat-sidenav>

    <!-- Main content -->
    <mat-sidenav-content cdkScrollable class="sidenav-main-content" >
      <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
        <!-- Page header -->
        <app-page-header [backgroundWhite]="false"
                         [bottomBorder]="false"
                         [section]="'Manage Spaces'"
                         [title]="'Setup and configure leasing spaces'"
                         [description]="'Manage and configure both available and unavailable leasing spaces\n'+
                      ''">
        </app-page-header>

        <!-- spaces list -->
        <app-list-spaces #listSpacesComponent
          class="page-padding"
          (spaceSelected)="selectedSpace = $event"
          [dirty]="selectedSpaceDirty || selectedSpacePricingDirty"
          [spaceUpdated]="updatedSpace"
          (addNewSpace)="addNewSpace = $event">
        </app-list-spaces>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>
  <ng-template #canvasLoadingSpinner>
    <div fxLayout="row" fxLayoutAlign="center center" style="height: 350px">
      <mat-spinner color="primary" diameter="30"></mat-spinner>
    </div>
  </ng-template>
